import API from '@/views/Fdc/Apis/'
import Dayjs from 'dayjs'
import { GridLayout, GridItem } from 'vue-grid-layout'

let mouseXY = { 'x': null, 'y': null }
let DragPos = { 'x': null, 'y': null, 'w': 1, 'h': 1, 'i': null }

export default {
  name: 'dynamicLayout',
  beforeMount () {
    this.initColumns()
  },
  components: {
    GridLayout,
    GridItem
  },
  mounted () {
    document.addEventListener('dragover', function (e) {
      mouseXY.x = e.clientX
      mouseXY.y = e.clientY
    }, false)
  },
  watch: {
    selectedTreeNode: function () {
      this.getEqpHostIpByNode(this.selectedTreeNode)
      this.getParameterListByNode(this.selectedTreeNode)
    },
    layout: function (newVal) {
      console.log(newVal)
    }
  },
  methods: {
    /**
     * Column initialize
     */
    initColumns () {
      this.paramColumns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.ALIAS_NAME'), field: 'aliasName', flex: 3, checkboxSelection: true, headerCheckboxSelection: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.PARAM_NAME'), field: 'paramName', hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.VIRTUAL'), field: 'virtualYn', flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.SPEC'), field: 'specYn', flex: 1 }
      ]
      this.eventColumns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.DATE_TIME'), field: 'dateTime', width: 140 },
        { headerName: this.$t('fdc.COMMON.COLUMN.EVENT'), field: 'eventName', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.LOT_ID'), field: 'lotId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.SUBST_ID'), field: 'substId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.SLOT'), field: 'slot', width: 70 },
        { headerName: this.$t('fdc.COMMON.COLUMN.RECIPE'), field: 'recipeId', width: 80 },
        { headerName: this.$t('fdc.COMMON.COLUMN.PROD_ID'), field: 'prodId', width: 80 },
        { headerName: this.$t('fdc.COMMON.COLUMN.OPER_ID'), field: 'operId', width: 80 },
        { headerName: this.$t('fdc.COMMON.COLUMN.PROCESS'), field: 'procId', width: 80 },
        { headerName: this.$t('fdc.COMMON.COLUMN.CARRIER_ID'), field: 'carrId', width: 80 }
      ]
      this.alarmColumns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.DATE_TIME'), field: 'dateTime', width: 140 },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODEL'), field: 'fdModel', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.TYPE'), field: 'fdType', width: 80 },
        { headerName: this.$t('fdc.COMMON.COLUMN.RESULT'), field: 'fdResult', width: 80 },
        { headerName: this.$t('fdc.COMMON.COLUMN.LSL'), field: 'lsl', width: 80 },
        { headerName: this.$t('fdc.COMMON.COLUMN.LCL'), field: 'lcl', width: 80 },
        { headerName: this.$t('fdc.COMMON.COLUMN.UCL'), field: 'ucl', width: 80 },
        { headerName: this.$t('fdc.COMMON.COLUMN.USL'), field: 'usl', width: 80 },
        { headerName: this.$t('fdc.COMMON.COLUMN.ALARM'), field: 'fdAlarm', width: 200 }
      ]
    },
    addEQPTreeItem () {
      console.log(this.index)
      this.layout.push({ 'x': 0, 'y': 10, 'w': 2, 'h': 6, 'i': '20', 'component': 'eqpTree' })
    },
    eqpTreeSelected (node) {
      this.selectedTreeNode = node
    },
    getEqpHostIpByNode (node) {
      this.getEqpHostIp(node.detail)
    },
    async getEqpHostIp (node) {
      if (node.moduleId === '') {
        return false
      }
      let eqpIdList = []
      eqpIdList.push(node.eqpId)
      let obj = { eqpId: eqpIdList + '' }
      let data = await API.Common.getEqpHostIps(obj)
      if (data) {
        this.eqpHostIpAddr = (data[node.eqpId] === '') ? 'localhost' : data[node.eqpId]
        console.log(this.eqpHostIpAddr)
      }
    },
    getParameterListByNode (node) {
      this.getParameterList(node.detail)
    },
    async getParameterList (node) {
      if (node.moduleId === '') {
        return false
      }
      let fabList = []
      let eqpIdList = []
      let moduleIdList = []
      fabList.push(node.fab)
      eqpIdList.push(node.eqpId)
      moduleIdList.push(node.moduleId)

      let obj = {
        fab: fabList + '',
        eqpId: eqpIdList + '',
        moduleId: moduleIdList + '',
        useYn: 'Y'
      }

      let data = await API.BaseInfo.getEqpsParams(obj)
      if (data) {
        this.paramList = [...data]
      }
    },
    getDateTime (date) {
      let year = date.substr(0, 4)
      let month = date.substr(4, 2)
      let day = date.substr(6, 2)
      let hour = date.substr(8, 2)
      let minute = date.substr(10, 2)
      let second = date.substr(12, 2)
      let millisecond = date.substr(14, 3)

      return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second + '.' + millisecond
    },
    trim (str) {
      return str.replace(/^\s+|\s+$/g, '')
    },
    getChartData (dataToChart, traceData) {
      let date = Dayjs(this.getDateTime(traceData.dateTime)).valueOf()
      this.setMinMax(date)
      traceData['x'] = date
      dataToChart.forEach((data) => {
        let tempStr = data.paramName
        traceData[tempStr] = parseFloat(data.paramVal)
        if (this.selectedParameter === data.paramName) {
          traceData['lsl'] = data.lsl
          traceData['usl'] = data.usl
          traceData['lcl'] = data.lcl
          traceData['ucl'] = data.ucl
        }
        this.chartData.push(traceData)
      })
      return this.chartData.slice()
    },
    setMinMax (x) {
      let time = 1000 * 60 * 5
      // xMin을 newPoint의 시간으로부터 1분간으로 설정
      if (x - this.xMin > time) {
        this.xMin = x - time
        this.chartData.shift()
      }
      // xMax는 새로 들어온 포인트의 시간으로 설정
      this.xMax = (x > this.xMax) ? x : this.xMax
    },
    async connect (isRealTime) {
      // let tempAlarmList = []
      // let tempEventList = []
      // let status = null
      // let alarmMessage = null
      // let lsl = 0
      // let usl = 0
      // let ucl = 0
      // let lcl = 0
      // let yMin = 0
      // let yMax = 1
      // let beforeStep = null
      // let tempStepList = []

      if (isRealTime) {
        // if (this.checkedRows.length === 0) {
        console.log(this.$refs.paramGrid)
        console.log(this.$refs.paramGrid[0].checkedRows)
        let checkedRows = this.$refs.paramGrid[0].checkedRows
        if (checkedRows.length === 0) {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', [this.$t('fdc.COMMON.LABEL.PARAMETER')]))
          return true
        }

        this.isRealTime = false
        this.isPushServiceStart = true

        var payload
        if (this.selectedTreeNode) {
          this.chartTitle = this.selectedTreeNode.detail.moduleId
          payload = {
            roomId: this.selectedTreeNode.detail.fab + this.selectedTreeNode.detail.eqpId + this.selectedTreeNode.detail.moduleId,
            hostIp: this.eqpHostIpAddr
          }
        } else {
          this.chartTitle = this.nodeObj.moduleId
          payload = {
            roomId: this.nodeObj.fab + this.nodeObj.eqpId + this.nodeObj.moduleId,
            hostIp: this.eqpHostIpAddr
          }
        }

        this.paramListDisabled(true)
        // document.getElementsByClassName("select-all")[0].disabled = true
        // let checkBoxList = document.getElementsByClassName("select-row")
        // for(var i = 0; i < checkBoxList.length; i++) {
        //   checkBoxList[i].disabled = true
        // }

        // real time room 조회 및 생성
        let result = await API.Monitor.startRealtimeMonitor(payload)
        response.hostIp = this.eqpHostIpAddr
        if (result) {
          this.ws = API.Monitor.connectStomp()
          var selectTreeNode = this.selectedTreeNode ? this.selectedTreeNode.detail : this.nodeObj
          var subUrl = selectTreeNode.fab + selectTreeNode.eqpId + selectTreeNode.moduleId
          let self = this
          this.ws.connect({}, function () {
            // trace data process
            self.ws.subscribe('/fdc/rts/trace/' + subUrl, function (message) { self.traceDataProcess(message) })
            // event data process
            self.ws.subscribe('/fdc/rts/event/' + subUrl, function (message) { self.eventDataProcess(message) })
          })
        } else {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.FAILED_EXEC_REQ'))
        }
      } else {
        this.isRealTime = true
        this.chartTitle = ''
        this.lotId = ''
        this.subStrId = ''
        // this.checkedRows = []
        // checkedRow에 대한 처리 확인 필요
        // this.getParameterList(this.selectedTreeNode.detail)
        this.dataToChart = []
        this.seriesData = []
        this.chartData = []
        this.eventList = []
        this.alarmList = []
        this.stepList = []
        this.selectedParameter = null
        this.checkedDataToChartRows = []
        this.yMax = null
        this.yMin = null
        this.paramListDisabled(false)
        // document.getElementsByClassName("select-all")[0].disabled = false
        // let checkBoxList = document.getElementsByClassName("select-row")
        // for(var j = 0; j < checkBoxList.length; j++) {
        //   checkBoxList[j].disabled = false
        // }
        if (this.ws !== null) {
          this.ws.disconnect()
        }
      }
    },
    // trace data 처리
    traceDataProcess (message) {
      // this.tempObj = [...JSON.parse('[' + message.body + ']')]
      let traceList = JSON.parse(message.body)
      console.log('traceList', traceList)
      let checkedRows = this.$refs.paramGrid[0].checkedRows
      let lsl = 0
      let usl = 0
      let ucl = 0
      let lcl = 0
      let yMin = this.yMin
      let yMax = this.yMax
      let alarmMessage = null
      let maxUsl = null
      let minLsl = null
      let beforeStep = this.beforeStep

      traceList.forEach(traceData => {
        this.deleteDataOverInterval(traceData)

        if (this.isPushServiceStart) {
          this.xMin = Dayjs(this.getDateTime(traceData.dateTime)).valueOf()
          this.xMax = Dayjs(this.getDateTime(traceData.dateTime)).add(5, 'minutes').valueOf()
          this.isPushServiceStart = false
        }

        console.log('this.dataToChart', this.dataToChart)

        this.dataToChart = traceData.paramDatas.filter((param) => {
          for (let checkedData of checkedRows) {
            if (checkedData.paramName === this.trim(param.paramName)) {
              if (yMax === null) yMax = parseFloat(param.paramVal)
              if (yMin === null) yMin = parseFloat(param.paramVal)

              if (parseFloat(param.paramVal) > yMax) {
                yMax = parseFloat(param.paramVal)
              }

              if (parseFloat(param.paramVal) < yMin) {
                yMin = parseFloat(param.paramVal)
              }

              // fdDatas를 이용한 Fault 로직 처리
              let fdDatas = [...param.fdDatas]
              if (fdDatas.length > 0) {
                fdDatas.forEach(fdData => {
                  if (maxUsl === null) maxUsl = parseFloat(fdData.fdSpec.usl)
                  if (maxUsl !== null && parseFloat(fdData.fdSpec.usl) > maxUsl) maxUsl = parseFloat(fdData.fdSpec.usl)
                  if (minLsl === null) minLsl = parseFloat(fdData.fdSpec.lsl)
                  if (minLsl !== null && parseFloat(fdData.fdSpec.lsl) < minLsl) minLsl = parseFloat(fdData.fdSpec.lsl)

                  usl = Math.round(parseFloat(fdData.fdSpec.usl).toFixed(4) * 10000) / 10000.0
                  ucl = Math.round(parseFloat(fdData.fdSpec.ucl).toFixed(4) * 10000) / 10000.0
                  lcl = Math.round(parseFloat(fdData.fdSpec.lcl).toFixed(4) * 10000) / 10000.0
                  lsl = Math.round(parseFloat(fdData.fdSpec.lsl).toFixed(4) * 10000) / 10000.0

                  let status = fdData.fdResult.toUpperCase()
                  console.log('status', status)
                  switch (status) {
                    case 'SAFE':
                      break
                    case 'FAULT':
                    case 'WARNING':
                      this.alarmList.unshift({
                        'dateTime': this.getDateTime(traceData.dateTime),
                        'fdModel': fdData.fdModel,
                        'fdType': fdData.fdType,
                        'usl': fdData.fdSpec.usl,
                        'ucl': fdData.fdSpec.ucl,
                        'lcl': fdData.fdSpec.lcl,
                        'lsl': fdData.fdSpec.lsl,
                        'fdResult': fdData.fdResult,
                        'fdAlarm': fdData.fdAlarm
                      })
                      console.log(this.alarmList)

                      alarmMessage = fdData.fdAlarm
                      break
                  }
                  param.usl = usl
                  param.ucl = ucl
                  param.lcl = lcl
                  param.lsl = lsl
                  param.status = status
                  param.alarmMessage = alarmMessage
                })
              }

              return true
            }
          }
        })

        // TODO :: 아래 로직도 for문 안쪽으로 이동!!!!!
        this.checkedDataToChartRows = [...this.dataToChart]
        if (this.checkedDataToChartRows.length === 1) {
          this.selectedParameter = this.checkedDataToChartRows[0].paramName
        }
        this.seriesData = this.getChartData(this.dataToChart, traceData)

        if (beforeStep === null) {
          beforeStep = traceData.step
          this.beforeStep = traceData.step
        } else if (beforeStep !== null && beforeStep !== traceData.step) {
          beforeStep = traceData.step
          this.stepList.unshift({
            'step': traceData.step,
            'annoDateTime': Dayjs(this.getDateTime(traceData.dateTime)).valueOf()
          })
          this.beforeStep = traceData.step
          console.log('this.stepList', this.stepList)
          // this.stepList = [...tempStepList]
        }
      })
      if (parseFloat(maxUsl) > yMax) {
        let calGapUsl = parseFloat(maxUsl - yMax)
        yMax = (yMax + calGapUsl)
      }
      if (parseFloat(minLsl) < yMin) {
        // let calGapLsl = parseFloat(minLsl - Math.sqrt(Math.pow(lsl, 2)))
        let calGapLsl = parseFloat(yMin - minLsl)
        yMin = (yMin - calGapLsl)
      }

      if (yMax !== this.yMax) this.yMax = (yMax + ((yMax - yMin) * 0.2))
      if (yMin !== this.yMin) this.yMin = (yMin - ((yMax - yMin) * 0.2))

      // console.log(yMin - ((yMax - yMin) * 0.2), yMax + ((yMax - yMin) * 0.2))
      // console.log(Math.floor(yMin - ((yMax - yMin) * 0.2)), Math.floor(yMax + ((yMax - yMin) * 0.2)))
    },
    // event data 처리
    eventDataProcess (message) {
      let eventData = JSON.parse(message.body)

      // LotId, SubStrId 차트에 어노테이션 표시
      this.lotId = eventData.lotId
      this.subStrId = eventData.prodMtrls[0].prodMtrlId
      let eventObj = {
        'dateTime': this.getDateTime(eventData.dateTime),
        'eventName': eventData.eventName,
        'lotId': eventData.lotId,
        'substId': eventData.prodMtrls[0].prodMtrlId,
        'slot': eventData.prodMtrls[0].slotNo,
        'recipeId': eventData.recipeId,
        'prodId': eventData.prodId,
        'operId': eventData.operId,
        'procId': eventData.procId,
        'carrId': eventData.carrId
      }
      if (eventData.eventName.indexOf('START') > -1) {
        eventObj.annoDateTime = Dayjs(this.getDateTime(eventData.dateTime)).valueOf()
        eventObj.annoValue = this.yMax
      }
      this.eventList.unshift(eventObj)
      // this.eventList = [...tempEventList]
    },
    // parameter list check box control
    paramListDisabled (value) {
      document.getElementsByClassName('select-all')[0].disabled = value
      let checkBoxList = document.getElementsByClassName('select-row')
      for (var i = 0; i < checkBoxList.length; i++) {
        checkBoxList[i].disabled = value
      }
    },
    // 5분 지난 data 삭제
    deleteDataOverInterval (traceData) {
      // 5분 이상 지난 Alarm은 제거
      if (this.alarmList.length > 0) {
        this.alarmList = this.alarmList.filter((alarm) => {
          if (Dayjs(this.getDateTime(traceData.dateTime)).valueOf() - Dayjs(alarm.dateTime).valueOf() < this.interval) {
            return alarm
          }
        })
      }

      // 5분 이상 지난 Event는 제거
      if (this.eventList.length > 0) {
        this.eventList = this.eventList.filter((event) => {
          if (Dayjs(this.getDateTime(traceData.dateTime)).valueOf() - Dayjs(event.dateTime).valueOf() < this.interval) {
            return event
          }
        })
      }

      // 5분 이상 지난 Step은 제거
      if (this.stepList.length > 0) {
        this.stepList = this.stepList.filter((event) => {
          if (Dayjs(this.getDateTime(traceData.dateTime)).valueOf() - Dayjs(event.annoDateTime).valueOf() < this.interval) {
            return event
          }
        })
      }
    },
    itemFormatter (engine, hitInfo, defaultRenderer) {
      let ht = hitInfo
      ht.item.paramDatas.forEach(param => {
        if (ht.name === param.paramName && param.status === 'WARNING') {
          engine.stroke = 'orange'
          engine.strokeWidth = 6
          engine.fill = 'rgb(255,127,0)'
        }

        if (ht.name === param.paramName && param.status === 'FAULT') {
          engine.stroke = 'red'
          engine.strokeWidth = 6
          engine.fill = 'rgb(255,0,0)'
        }
      })
      defaultRenderer()
    },
    tooltipContent (hti) {
      if (!hti.name) {
        return false
      }

      let item = hti.item
      let result = ''
      let alarmMessage = ''
      let lsl = null
      let usl = null
      let lcl = null
      let ucl = null

      hti.item.paramDatas.forEach(param => {
        if (hti.name === param.paramName && param.status === 'WARNING') {
          result = 'WARNING'
          alarmMessage = param.alarmMessage
          lsl = param.lsl
          usl = param.usl
          lcl = param.lcl
          ucl = param.ucl
        } else if (hti.name === param.paramName && param.status === 'FAULT') {
          result = 'FAULT'
          alarmMessage = param.alarmMessage
          lsl = param.lsl
          usl = param.usl
          lcl = param.lcl
          ucl = param.ucl
        } else if (hti.name === param.paramName && param.status === 'SAFE') {
          result = 'SAFE'
          lsl = param.lsl
          usl = param.usl
          lcl = param.lcl
          ucl = param.ucl
        }
      })

      let tooltipText = `<b>Time</b>: ${this.getDateTime(item.dateTime)}</br>
        <b>Lot ID</b>: ${item.lotId}</br>
        <b>Substrate</b>: ${item.prodMtrls[0].prodMtrlId}</br>
        <b>Recipe</b>: ${item.recipeId}</br>
        <b>Step</b>: ${item.step}</br>
        <b>Parameter</b>: ${hti.series.binding}</br>
        <b>Value</b>: ${hti.value}</br>`

      if (lsl === null && usl === null && lcl === null && ucl === null) {
        return tooltipText
      } else {
        return tooltipText + `<b>Result</b>: ${result}</br>
          <b>Spec</b>: ${lsl}, ${lcl}, ${ucl}, ${usl}</br>
          <b>Alarm</b>: ${alarmMessage}</br>`
      }
    },
    // layout 관련 function
    // drag & drop
    drag: function (value) {
      let parentRect = document.getElementById('content').getBoundingClientRect()
      let mouseInGrid = false
      if (((mouseXY.x > parentRect.left) && (mouseXY.x < parentRect.right)) && ((mouseXY.y > parentRect.top) && (mouseXY.y < parentRect.bottom))) {
        mouseInGrid = true
      }
      if (mouseInGrid === true && (this.layout.findIndex(item => item.i === 'drop')) === -1) {
        this.layout.push({
          x: (this.layout.length * 2) % (this.colNum || 12),
          y: this.layout.length + (this.colNum || 12), // puts it at the bottom
          w: 1,
          h: 1,
          i: 'drop'
        })
      }
      let index = this.layout.findIndex(item => item.i === 'drop')
      if (index !== -1) {
        try {
          this.$refs.gridlayout.$children[this.layout.length].$refs.item.style.display = 'none'
        } catch {
          console.log('error')
        }
        let el = this.$refs.gridlayout.$children[index]
        el.dragging = { 'top': mouseXY.y - parentRect.top, 'left': mouseXY.x - parentRect.left }
        let newPos = el.calcXY(mouseXY.y - parentRect.top, mouseXY.x - parentRect.left)
        if (mouseInGrid === true) {
          this.$refs.gridlayout.dragEvent('dragstart', 'drop', newPos.x, newPos.y, 1, 1)
          DragPos.i = String(index)
          DragPos.x = this.layout[index].x
          DragPos.y = this.layout[index].y
        }
        if (mouseInGrid === false) {
          this.$refs.gridlayout.dragEvent('dragend', 'drop', newPos.x, newPos.y, 1, 1)
          this.layout = this.layout.filter(obj => obj.i !== 'drop')
        }
      }
    },
    dragend: function (value) {
      console.log('dragend', value)
      let parentRect = document.getElementById('content').getBoundingClientRect()
      let mouseInGrid = false
      if (((mouseXY.x > parentRect.left) && (mouseXY.x < parentRect.right)) && ((mouseXY.y > parentRect.top) && (mouseXY.y < parentRect.bottom))) {
        mouseInGrid = true
      }
      if (mouseInGrid === true) {
        alert(`Dropped element props:\n${JSON.stringify(DragPos, ['x', 'y', 'w', 'h'], 2)}`)

        this.$refs.gridlayout.dragEvent('dragend', 'drop', DragPos.x, DragPos.y, 1, 1)
        this.layout = this.layout.filter(obj => obj.i !== 'drop')

        if (value === 'EQPTree') {
          this.layout.push({ 'x': DragPos.x, 'y': DragPos.y, 'w': 2, 'h': 6, 'i': 'EQPTree' })
        } else if (value === 'ParamList') {
          this.layout.push({ 'x': DragPos.x, 'y': DragPos.y, 'w': 2, 'h': 4, 'i': 'ParamList' })
        } else if (value === 'SearchButton') {
          this.layout.push({ 'x': DragPos.x, 'y': DragPos.y, 'w': 2, 'h': 2, 'i': 'SearchButton' })
        } else if (value === 'RealTimeChart') {
          this.layout.push({ 'x': DragPos.x, 'y': DragPos.y, 'w': 4, 'h': 6, 'i': 'RealTimeChart' })
        } else if (value === 'EventGrid') {
          this.layout.push({ 'x': DragPos.x, 'y': DragPos.y, 'w': 4, 'h': 6, 'i': 'EventGrid' })
        } else if (value === 'FaultGrid') {
          this.layout.push({ 'x': DragPos.x, 'y': DragPos.y, 'w': 4, 'h': 6, 'i': 'FaultGrid' })
        }
        // UNCOMMENT below if you want to add a grid-item
        /*
        this.layout.push({
            x: DragPos.x,
            y: DragPos.y,
            w: 1,
            h: 1,
            i: DragPos.i,
        });
        this.$refs.gridLayout.dragEvent('dragend', DragPos.i, DragPos.x,DragPos.y,1,1);
        try {
            this.$refs.gridLayout.$children[this.layout.length].$refs.item.style.display="block";
        } catch {
        }
        */
      }
    },
    layoutUpdatedEvent () {
      console.log('this.layout', this.layout)
    },
    saveLayout () {
      console.log('saveLayout', JSON.stringify(this.layout))
      // TODO :: 저장 시 일단 layout 메뉴 밑으로 넣고 그 다음에 메뉴를 구성할 수 있는 manager가 따로 필요할 듯!

      // 2022.03 API Refactoring - saveCustomLayout API 제거
      // if (this.saveDataValidCheck()) {
      //   let payload = {
      //     pageName: 'Custom Layout',
      //     pageUrl: '/fdc/dynamic-layout/custom-layout',
      //     pageLayout: JSON.stringify(this.layout)
      //   }
      //   const that = this
      //   let message = ''
      //   const successMessage = this.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE')
      //   const failMessage = this.$t('fdc.COMMON.MESSAGE.FAILED_SAVE')

      //   message += this.$t('fdc.COMMON.MESSAGE.CONFIRM_SAVE')
      //   this.$dialog.confirm({
      //     message: message,
      //     cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
      //     confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
      //     onConfirm: async function () {
      //       const responseData = await API.FdcManagement.saveCustomLayout(payload)
      //       if (responseData != null && responseData.status === 200) {
      //         that.$dialog.alert(successMessage)
      //         console.log(responseData)
      //         // that.refreshModel()
      //       } else {
      //         that.$dialog.alert(failMessage)
      //       }
      //     }
      //   })
      // } else {
      //   this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_EXIST', ['Layout Items']))
      // }
    },
    saveDataValidCheck () {
      if (this.layout.length > 0) {
        return true
      } else {
        return false
      }
    }
  },
  data () {
    return {
      layout: [],
      index: 0,
      theChart: null,
      selectedParameter: 'Select a parameter',
      isPushServiceStart: false,
      treeNodes: [],
      seriesData: [],
      checkedRows: [],
      checkedDataToChartRows: [],
      dataToChart: [],
      isRealTime: true,
      paramList: [],
      selectedTreeNode: null,
      ws: null,
      tempObj: null,
      nodeObj: null,
      eventList: [],
      alarmList: [],
      stepList: [],
      chartData: [],
      chartTitle: '',
      lotId: '',
      subStrId: '',
      xMin: null,
      xMax: null,
      yMin: null,
      yMax: null,
      interval: 5 * 60 * 1000,
      beforeStep: null,
      paramColumns: [], // Parameter List grid column 배열
      eventColumns: [], // Event List grid column 배열
      alarmColumns: [], // Fault List grid column 배열
      defaultColDef: {
        // minWidth: 100,
        filter: true,
        sortable: true,
        resizable: true
      }, // BRIQUE Grid column default setting
      // paramColumns: [
      //   { label: this.$t('fdc.COMMON.COLUMN.ALIAS_NAME'), binding: 'aliasName', width: '4*', readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.VIRTUAL'), binding: 'virtualYn', width: '1*', readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.SPEC'), binding: 'specYn', width: '1*', readOnly: true }
      // ],
      // eventColumns: [
      //   { label: this.$t('fdc.COMMON.COLUMN.DATE_TIME'), binding: 'dateTime', width: 140, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.EVENT'), binding: 'eventName', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.LOT_ID'), binding: 'lotId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.SUBST_ID'), binding: 'substId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.SLOT'), binding: 'slot', width: 70, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.RECIPE'), binding: 'recipeId', width: 80, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.PROD_ID'), binding: 'prodId', width: 80, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.OPER_ID'), binding: 'operId', width: 80, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.PROCESS'), binding: 'procId', width: 80, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.CARRIER_ID'), binding: 'carrId', width: 80, readOnly: true }
      // ],
      // alarmColumns: [
      //   { label: this.$t('fdc.COMMON.COLUMN.DATE_TIME'), binding: 'dateTime', width: 140, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODEL'), binding: 'fdModel', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.TYPE'), binding: 'fdType', width: 80, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.RESULT'), binding: 'fdResult', width: 80, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.LSL'), binding: 'lsl', width: 80, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.LCL'), binding: 'lcl', width: 80, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.UCL'), binding: 'ucl', width: 80, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.USL'), binding: 'usl', width: 80, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.ALARM'), binding: 'fdAlarm', width: 200, readOnly: true }
      // ],
      eqpHostIpAddr: ''
    }
  }
}
